import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=4b28be12"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b28be12')) {
      api.createRecord('4b28be12', component.options)
    } else {
      api.reload('4b28be12', component.options)
    }
    module.hot.accept("./Course.vue?vue&type=template&id=4b28be12", function () {
      api.rerender('4b28be12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/pages/Course.vue"
export default component.exports